/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
import * as PropTypes from "prop-types";
export var columnInteractionBarContextTypes = {
    enableColumnInteractionBar: PropTypes.bool,
};
